import { IneligibleScreen } from "../ResultScreens";
import { MentalHealthPageData } from "./MentalHealthRoot";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { ProgrammeProps } from "../Props";

export interface IneligibleEatingDisorderScreenProps extends ProgrammeProps {
  mentalHealthPageData: MentalHealthPageData;
}

const IneligibleEatingDisorderScreen: React.FC<IneligibleEatingDisorderScreenProps> = (
  props: IneligibleEatingDisorderScreenProps
) => {
  const { programmeTitle, mentalHealthPageData } = props;

  const ineligible_page_title = `Ineligible mental health | ${programmeTitle} | ${pageTitleSuffix}`;

  return (
    <IneligibleScreen
      title={ineligible_page_title}
      heading={mentalHealthPageData.ineligibleScreens.ineligibleEatingDisorder.title}
      bodyText={mentalHealthPageData.ineligibleScreens.ineligibleEatingDisorder.body}
      hasContactUs={true}
    />
  );
};

export default IneligibleEatingDisorderScreen;
